'use client';

import ErrorScreen from '@/components/common/error-screen';

const Error = ErrorScreen;

export default Error;
